var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPayment = function SvgPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 82,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#959DA8",
    strokeMiterlimit: 10,
    strokeWidth: 2.002,
    d: "M143.576 48.06v30.036a2.01 2.01 0 0 1-2.002 2.002H21.327a2.01 2.01 0 0 1-2.003-2.002V3.004c0-1.101.901-2.003 2.003-2.003h120.247c1.101 0 2.002.902 2.002 2.003v37.045M19.324 11.014h124.252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#959DA8",
    d: "M24.53 7.61a1.802 1.802 0 1 0 0-3.605 1.802 1.802 0 0 0 0 3.605M30.136 7.61a1.802 1.802 0 1 0 0-3.605 1.802 1.802 0 0 0 0 3.605M35.744 7.61a1.802 1.802 0 1 0 0-3.605 1.802 1.802 0 0 0 0 3.605"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#959DA8",
    strokeMiterlimit: 10,
    strokeWidth: 2.002,
    d: "M123.752 44.054h36.745m-3.604-4.105 4.004 4.105-4.004 4.105"
  })));
};
export default SvgPayment;